import useIsStore from '@hooks/useIsStore'
import dynamic from 'next/dynamic'

const LongOrCompactCPG = dynamic(() => import('./LongOrCompactCPG'))
const Products = dynamic(() => import('./Products'))

export default function LongOrCompactLayout(props) {
  const {
    website,
    layout,
    menuId,
    nextOpenDate,
    preferences,
    productCardDesign,
    categories,
    productsLayout,
    loading
  } = props
  const isStore = useIsStore()

  return isStore ? (
    <LongOrCompactCPG
      website={website}
      productsLayout={productsLayout}
      layout={layout}
      menuId={menuId}
      loading={loading}
      nextOpenDate={nextOpenDate}
      preferences={preferences}
      productCardDesign={productCardDesign}
      storeId={preferences?.store?._id}
      deliverAt={preferences?.deliverAt}
    />
  ) : (
    <Products
      website={website}
      productsLayout={productsLayout}
      layout={layout}
      menuId={menuId}
      loading={loading}
      nextOpenDate={nextOpenDate}
      preferences={preferences}
      productCardDesign={productCardDesign}
      preloadedCategories={categories}
      storeId={preferences?.store?._id}
      deliverAt={preferences?.deliverAt}
    />
  )
}
